import { gatewayPhone } from "../../../../gateways/gatewayPhone";
import { SmsMessage } from "../chat/types/SmsMessage";
import { InboundType } from "../../contacts/enums/inbound.enums";

export interface PaginatedSmsResponse {
  data: SmsMessage[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
}

interface FetchChatSmsParams {
  phoneNumber: string;
  from: string;
  companyId?: number | string | null;
  pageParam?: number;
  limit?: number;
  search?: string;
}

export const fetchChatSms = async ({
  phoneNumber,
  from,
  companyId,
  pageParam = 1,
  limit = 20,
  search = "",
}: FetchChatSmsParams): Promise<PaginatedSmsResponse> => {
  const token = sessionStorage.getItem("token");

  if (!token) {
    throw new Error("No auth token found");
  }

  const { data } = await gatewayPhone.get<PaginatedSmsResponse>(
    `inbound-records/self/${phoneNumber}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        ...(companyId != null && { "x-company-id": String(companyId) }),
      },
      params: {
        fromNumber: from,
        type: InboundType.MESSAGE,
        page: pageParam,
        limit,
        ...(search.trim() && { search: search.trim() }),
      },
    }
  );

  return data;
};
